import {
  FETCH_VENUES_REQUESTED,
  FETCH_VENUES_SUCCEDED,
  FETCH_VENUES_FAILED,
  SELECT_VENUE,
} from './actionTypes'

import api from 'utils/api'

export const fetchVenues = () => (dispatch) => {
  dispatch(fetchVenuesRequested())

  return api
    .fetchVenues()
    .then(({ data }) => dispatch(fetchVenuesAction(data)))
    .catch(() => {
      dispatch(fetchVenuesFailed())
    })
}

export const selectVenue = (venueUuid) => ({
  type: SELECT_VENUE,
  payload: venueUuid,
})

export const fetchVenuesRequested = () => ({
  type: FETCH_VENUES_REQUESTED,
})

export const fetchVenuesAction = (venues) => ({
  type: FETCH_VENUES_SUCCEDED,
  payload: venues,
})

export const fetchVenuesFailed = () => ({
  type: FETCH_VENUES_FAILED,
})
